export default "__VITE_ASSET__dfb3fcbf__"